import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';
import { formatGraphqlErrors } from 'utils/helpers';
import { useMutation } from '@apollo/client/react';
import { ForgotPasswordDocument } from 'graphql/generated/graphql';

const useForgotPassword = () => {
  const { formatMessage: t } = useIntl();
  const [forgotPasswordMutation] = useMutation(ForgotPasswordDocument, {
    onCompleted: () => toast.success(t({ id: 'auth.forgot_password.message' })),
    onError: (e) => toast.error(formatGraphqlErrors(e).message),
  });

  const forgotPassword = useCallback(
    async ({ email }: { email: string }) => {
      try {
        await forgotPasswordMutation({ variables: { email } });
      } catch {
        // onError has handled the error: with an onError option the mutation resolved under Apollo Client 2,
        // Apollo Client 4 rejects after calling it.
      }
    },
    [forgotPasswordMutation],
  );

  return forgotPassword;
};

export default useForgotPassword;
